import { render, staticRenderFns } from "./modalSeeMoreProducts.vue?vue&type=template&id=59ff0bd4&"
import script from "./modalSeeMoreProducts.vue?vue&type=script&lang=js&"
export * from "./modalSeeMoreProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports